import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-field" }
const _hoisted_2 = { class: "gfu-field__label" }
const _hoisted_3 = { class: "_flex _ai-fs" }
const _hoisted_4 = { class: "_ml-2 _mt-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_number_field = _resolveComponent("number-field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.Resources.Product.SplitItemAmountLabel), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      ($props.isSecondary)
        ? (_openBlock(), _createBlock(_component_number_field, {
            key: 0,
            ref: "amountField",
            modelValue: $data.draft,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.draft) = $event)),
            name: "draft",
            "display-name": _ctx.Resources.Product.SplitItemAmountLabel,
            "show-label": false,
            integer: true,
            maxlength: 5,
            "text-align": "left",
            class: "_grow-1 _mt-0",
            "data-qa": "quantity-field"
          }, null, 8 /* PROPS */, ["modelValue", "display-name"]))
        : (_openBlock(), _createBlock(_component_number_field, {
            key: 1,
            "model-value": $props.quantity,
            "read-only": true,
            "show-label": false,
            integer: true,
            "text-align": "left",
            class: "_grow-1 _mt-0",
            "data-qa": "quantity-field"
          }, null, 8 /* PROPS */, ["model-value"])),
      _createElementVNode("div", _hoisted_4, [
        (!$props.isSecondary)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              enabled: !$props.canProductBeSplit,
              text: _ctx.Resources.Product.SplitItemAllCopiesAssignedTooltipText,
              class: "_flexinline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_base_button, {
                  "icon-namespace": "ga",
                  icon: "split-icon",
                  "only-icon": true,
                  theme: "lightFlat",
                  shape: "circle",
                  enabled: $props.canProductBeSplit,
                  title: _ctx.Resources.Product.SplitItemSplitButtonTitle,
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('split'))),
                  "data-qa": "split-button"
                }, null, 8 /* PROPS */, ["enabled", "title"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["enabled", "text"]))
          : (_openBlock(), _createBlock(_component_icon_base_button, {
              key: 1,
              icon: "trash-alt",
              "only-icon": true,
              theme: "lightFlat",
              shape: "circle",
              title: _ctx.Resources.Product.SplitItemRemoveButtonTitle,
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('remove'))),
              "data-qa": "remove-button"
            }, null, 8 /* PROPS */, ["title"]))
      ])
    ])
  ]))
}